<template>
  <component :is="template"></component>
</template>

<script>
import { STORE_KEY } from "./_store/constants";
import store from "./_store";
import UserProfile from "./_components/UserProfile";
import UserActivity from "./_components/UserActivity";
import UserExamList from "./_components/UserExamList";
import UserExamRecent from "./_components/UserExamRecent";
import UserTopup from "./_components/UserTopup";

export default {
  name: "UserModule",
  components: {
    UserProfile,
    UserActivity,
    UserExamList,
    UserExamRecent,
    UserTopup
  },
  props: {
    template: String
  },
  created() {
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }
}
</script>
